<template>
  <ImgLazy
    :image-url="imageUrl"
    :alt-text="altText"
    aspect-ratio="1"
    :width="100"
    :height="100"
    class="top-brand-icon-container"
  />
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      required: false,
      default: 'brand-icon'
    }
  }
}
</script>

<style lang="scss" scoped>
.top-brand-icon-container {
  @extend %hover-common;
  box-sizing: border-box;
  border: 1px solid $gray-2;
  border-radius: 8px;
}
</style>
